import { Controller } from "@hotwired/stimulus";

// Generic click-to-open info popover -- a small icon button that reveals a
// positioned panel of rich (real HTML, not a plain-text title attribute)
// content next to it. Closes on a second click or a click anywhere outside
// (same pattern passenger_picker_controller.js already uses).
export default class extends Controller {
  static targets = ["panel"];

  connect() {
    this.boundClose = this.closeOnOutsideClick.bind(this);
    document.addEventListener("click", this.boundClose);
  }

  disconnect() {
    document.removeEventListener("click", this.boundClose);
  }

  toggle(event) {
    event.stopPropagation();
    this.panelTarget.classList.toggle("hidden");
  }

  close() {
    this.panelTarget.classList.add("hidden");
  }

  closeOnOutsideClick(event) {
    if (!this.element.contains(event.target)) this.close();
  }
}
